<script setup lang="ts"></script>

<template>
	<router-view />
</template>

<route lang="yaml">
meta:
  layout: auth
</route>
